import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { catchError, ReplaySubject, Subject, takeUntil, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { GroupService } from 'src/app/services/group.service';
import { AddNewGroupComponent } from '../add-new-group/add-new-group.component';
import { SampleGroupModel } from 'src/app/models/sample-group-model';
import { Group } from 'src/app/models/group';

@Component({
    selector: 'app-merge-groups',
    templateUrl: './merge-groups.component.html',
    styleUrls: ['./merge-groups.component.css'],
    standalone: false
})
export class MergeGroupsComponent implements OnInit, OnDestroy {

  newGroupForm: FormGroup;

  userId:number = 0;
  tenantId:number = 0;

  public groupFilterCtrl: FormControl<string> = new FormControl<string>('');
  public filteredSampleGroups: ReplaySubject<SampleGroupModel[]> = new ReplaySubject<SampleGroupModel[]>(1);
  protected _onGroupDestroy = new Subject<void>();
  groups = [];
  group: Group;
  selectedGroups: number[] = [];
  showGroupDropdown = false;
  showNewGroupInput = false;
  newGroupName = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public cancelAddGroupDialog: MatDialogRef<AddNewGroupComponent>,
      private newGroupFb: FormBuilder,
      public addGroupDialog: MatDialog,
      private groupService: GroupService,
      public nav: NavBarComponent,
  ) {
    this.newGroupForm = this.newGroupFb.group({
      sampleGroup: new FormControl(null)
    });
  }
  ngOnInit(): void {
    if(this.data){
      this.userId = this.data.userId;
      this.tenantId = this.data.tenantId;
      this.selectedGroups = this.data.selectedGroups;
    }

    this.populateGroupDropdown();
  }

  populateGroupDropdown(groupId?: number){
    this.groupService.getGroups(this.tenantId).pipe(
        catchError(error =>{
          console.error();
          return throwError(()=> error);
        })
    ).subscribe((result) =>{
      for(let group of result) {
        if(!this.selectedGroups?.includes(group?.id)) {
          this.groups.push(group);
        }
      }

      if(groupId) {
        let group = this.groups.find(g => g.id === groupId);
        this.newGroupForm.controls.sampleGroup.setValue(group);
      }
      this.setInitialGroupList();
      this.nav.toggleLoading(false);
    })
  }

  setInitialGroupList() {
    // Load the initial group list
    this.filteredSampleGroups.next(this.groups.slice());
    // Listen for search field value changes
    this.groupFilterCtrl.valueChanges
      .pipe(takeUntil(this._onGroupDestroy))
      .subscribe(() => {
        this.filterGroups();
      });
  }


  protected filterGroups() {
    if (!this.groups) {
      return;
    }
    // Get the search keyword
    let search = this.groupFilterCtrl.value;
    if (!search) {
      this.filteredSampleGroups.next(this.groups.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // Filter the group based on the search keyword
    this.filteredSampleGroups.next(
      this.groups.filter(group => group.name.toLowerCase().indexOf(search) > -1)
    );
  }


  addNewGroup(){
    this.createAndSelectGroup();
  }

  createAndSelectGroup() {
    const name = this.groupFilterCtrl.value?.trim();
    if (!name) return;
    this.groupService.postNewGroup(this.userId, this.tenantId, name).pipe(
      catchError(error => { console.error(error); return throwError(() => error); })
    ).subscribe((res) => {
      const newGroup = { id: res.id, name: name };
      this.groups.push(newGroup);
      this.setSelectedGroup(newGroup);
      this.groupFilterCtrl.setValue(name);
      this.showGroupDropdown = false;
    });
  }

  hasExactMatch(): boolean {
    const val = this.groupFilterCtrl.value?.toLowerCase().trim();
    if (!val) return true;
    return this.groups.some(g => g.name.toLowerCase() === val);
  }


  close(){
    this.cancelAddGroupDialog.close({"option": "cancel"});
  }

  setSelectedGroup(group){
      this.group = group;
      this.newGroupForm.controls.sampleGroup.setValue(this.group);

  }

  merge(){
        this.nav.toggleLoading(true);
       let  groupObj = {
          option: 'merge',
          groupId: this.group.id
        }
        this.cancelAddGroupDialog.close({groupObj});
        this.nav.toggleLoading(false);
  }

  ngOnDestroy() {
    this._onGroupDestroy.next();
    this._onGroupDestroy.complete();
  }
}
